import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DragSource, DropTarget } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'

const imageSource = {
  beginDrag(props) {
    const { id, position, url } = props
    const draggedImage = { id, position, url }
    let images
    if (props.selectedImages.find(image => image.id === props.id)) {
      images = props.selectedImages
    } else {
      images = [draggedImage]
    }
    const otherImages = images.concat()
    otherImages.splice(images.findIndex(c => c.id === props.id), 1)
    const imagesDragStack = [draggedImage, ...otherImages]
    return { images, imagesDragStack, draggedImage }
  },

  endDrag(props, monitor) {
    props.onDragComplete(monitor.getItem())
  },
}

const imageTarget = {
  hover(props, monitor, component) {
    const item = monitor.getItem()
    const pointerOffset = monitor.getClientOffset()
    const hoverId = props.id
    props.onMove(item, hoverId, pointerOffset)
  },
}

class Image extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dataUpdated: false,
    }

    this.onClick = this.onClick.bind(this)
  }

  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true,
    })
  }

  // This one does not work when converted to componentDidUpdate. Potential risk for continues migration
  componentWillReceiveProps(nextProps, nextState) {
    if (!this.props.isDragging && nextProps.isDragging) {
      this.props.onDragStart(nextProps.item)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.dataUpdated && prevProps.imageProps === this.props.imageProps) {
      this.setState({ dataUpdated: false })
    }

    if (prevProps.imageProps !== this.props.imageProps) {
      this.setState({ dataUpdated: true })
    }
  }

  onClick(e) {
    this.props.onSelectionChange(this.props.id, e.metaKey, e.shiftKey)
  }

  render() {
    if (!this.state.dataUpdated && this.renderCache) {
      return this.renderCache
    }

    const { imageComponent: Component } = this.props

    this.renderCache = this.props.connectDragSource(
      this.props.connectDropTarget(
        <div ref={node => (this.node = node)} onClick={this.onClick}>
          <Component
            id={this.props.id}
            url={this.props.url}
            imageProps={this.props.imageProps}
            onRemove={this.props.onRemove}
          />
        </div>
      )
    )

    return this.renderCache
  }
}

Image.propTypes = {
  connectDragSource: PropTypes.func,
  connectDragPreview: PropTypes.func,
  connectDropTarget: PropTypes.func,
  onSelectionChange: PropTypes.func,
  isDragging: PropTypes.bool,
  item: PropTypes.object,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  position: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  imageProps: PropTypes.object.isRequired,
  onMove: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDragComplete: PropTypes.func.isRequired,
  selectedImages: PropTypes.array.isRequired,
  imageComponent: PropTypes.func.isRequired,
}

const ImageWithDropTarget = DropTarget('image', imageTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))(Image)

const ImageWithDragSource = DragSource('image', imageSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
  item: monitor.getItem(),
}))(ImageWithDropTarget)

export default ImageWithDragSource
